import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-print-icon',
  templateUrl: './print-icon.component.html',
  styleUrls: ['./print-icon.component.scss']
})
export class PrintIconComponent {
  @Input() icon: string = '';
  @Input() customPath?: string;

  useCustom = true;

  onError(): void {
    this.useCustom = false;
  }
}
